__turbopack_context__.v({
  "badge": "_76VLKW_badge",
  "banner": "_76VLKW_banner",
  "cta": "_76VLKW_cta",
  "link": "_76VLKW_link",
  "message": "_76VLKW_message",
});
